import React, { memo } from "react";

function IconMedicalHistory({ color = "#FFF", ...props }) {
  return (
    <svg
      {...props}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6364 6.63666V13.1821H16.2727M25 12.8185C25 19.4459 19.6274 24.8185 13 24.8185C6.37258 24.8185 1 19.4459 1 12.8185C1 6.19106 6.37258 0.818481 13 0.818481C19.6274 0.818481 25 6.19106 25 12.8185Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(IconMedicalHistory);
